import { SelectOptionWithAvatar } from '@components/common';

import { IOrganisationSwitchEntity } from '@interfaces/organisation/organisations';

export const formatOptionsLabelWithAvatar = (option: IOrganisationSwitchEntity) => {
	const isDisabledOption = !option.isActive || !option.isEnabled;

	return {
		isDefault: option.isFavourite,
		value: option.id,
		avatar: option.avatar,
		disabled: isDisabledOption,
		title: option.legalName,
		label: (
			<SelectOptionWithAvatar
				id={option?.avatar?.id}
				isDisabled={isDisabledOption}
				text={option.legalName}
			/>
		),
	};
};
